export default {
  text: 'Acest restaurant este suspendat. Vă rugăm să contactați persoana de contact sau scrieți-ne la <a>{{supportEmail}}</a> dacă doriți să îl restaurați',
};
